import { render } from "./AdminFooter.vue?vue&type=template&id=82decd92"
const script = {}

import "./AdminFooter.vue?vue&type=style&index=0&id=82decd92&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__